module.exports = __webpack_public_path__ + "static/img/foltest_commander.318660a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cards/northern/foltest_commander.png
// module id = lmy7
// module chunks = 0